<template>
  <div class="traffic-page">
    <div class="content-card">
      <div class="card-header">
        <a-icon type="line-chart" class="header-icon" />
        <div class="header-title">{{ translate('traffic.title') }}</div>
      </div>

      <a-form
        :model="formData"
        @submit.prevent="onSubmit"
        layout="inline"
        :style="{ marginBottom: '20px' }"
      >
        <a-form-item :label="translate('traffic.form.subAccount')">
          <a-select
            v-model="formData.uname"
            :placeholder="translate('traffic.form.selectSubAccount')"
            style="min-width: 220px"
            allow-clear
            @change="changeSon"
            @clear="handleClear"
          >
            <a-select-option value="all">{{ translate('traffic.form.all') }}</a-select-option>
            <a-select-option
              v-for="item in sonlist"
              :key="item.upid"
              :value="item.username"
            >
              {{ item.username }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="onSubmit">{{ translate('traffic.form.search') }}</a-button>
        </a-form-item>
      </a-form>

      <!-- echarts图表容器 -->
      <div
        id="traffic-chart"
        class="traffic-chart"
        style="width: 100%; height: 520px; background: #fff"
      ></div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import * as echarts from 'echarts'

export default {
  name: 'TrafficPage',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formData: {
        uname: 'all',
      },
      timer: '', // 定时器名称
      sonlist: [],
      flowlist: [],
      timelist: [],
      uid: localStorage.getItem('userId'),
      charts: null,
    }
  },
  watch: {
    'formData.uname'(newVal) {
      if (newVal === undefined || newVal === null) {
        this.formData.uname = 'all'
      }
    }
  },
  methods: {
    // 国际化翻译方法
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'traffic.title': lang === 'zh' ? '流量使用概括' : 'Traffic Usage Summary',
        'traffic.form.subAccount': lang === 'zh' ? '子账户' : 'Sub Account',
        'traffic.form.selectSubAccount': lang === 'zh' ? '请选择子账户' : 'Please select sub account',
        'traffic.form.all': lang === 'zh' ? '全部' : 'All',
        'traffic.form.search': lang === 'zh' ? '查询' : 'Search',
        'traffic.chart.title': lang === 'zh' ? '流量使用趋势' : 'Traffic Usage Trend',
        'traffic.chart.yAxis': lang === 'zh' ? '流量(G)' : 'Traffic (G)',
        'traffic.message.loginWarning': lang === 'zh' ? '请重新登录！' : 'Please login again!',
      };
      return translations[key] || key;
    },
    // 登录状态检查
    getLoginStatus() {
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear()
          message.warning(this.translate('traffic.message.loginWarning'))
        }
      })
        .catch((e) => {
          console.log(e)
        })
    },
    // 启动定时检查
    start() {
      this.timer = setInterval(this.getLoginStatus, 10000)
    },
    // 初始化图表
    initChart(id) {
      if (!this.charts || this.charts.isDisposed()) {
        this.charts = echarts.init(document.getElementById(id))
      }
    },
    // 更新图表数据
    updateChart(data) {
      if (!this.charts) {
        this.initChart('traffic-chart')
      }
      
      if (this.charts) {
        this.flowlist = []
        this.timelist = []
        data.forEach((item) => {
          this.flowlist.push(item.flowOverdueChange)
          this.timelist.push(item.createrTime)
        })
        
        this.charts.setOption({
          title: {
            left: '3%',
            top: '2%',
            text: this.translate('traffic.chart.title'),
          },
          tooltip: {
            trigger: 'axis',
          },
          grid: {
            top: '20%',
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            axisTick: {
              alignWithLabel: true,
            },
            data: this.timelist,
          },
          yAxis: {
            name: this.translate('traffic.chart.yAxis'),
            type: 'value',
            boundaryGap: true,
          },
          series: [{
            type: 'line',
            data: this.flowlist,
            smooth: true,
            lineStyle: {
              width: 2,
            },
            itemStyle: {
              radius: 4,
            },
          }],
        }, true)
      }
    },
    // 绘制折线图
    drawLine(id) {
      this.initChart(id)
      this.fetchTrafficData()
    },
    // 获取流量数据
    fetchTrafficData() {
      this.$request.get(`/his/polyline?uname=${this.formData.uname}&uid=${this.uid}`).then((res) => {
        if (res.data.code === 200) {
          this.updateChart(res.data.data)
        }
      }).catch((e) => { console.log(e) })
    },
    // 子账户变化监听
    changeSon() {
      this.$request.get(`/ums/Pro/selectSonAccount?id=${this.uid}`).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data
        }
      }).catch((e) => { console.log(e) })
    },
    // 查询提交
    onSubmit() {
      this.fetchTrafficData()
    },
    // 处理清空事件
    handleClear() {
      this.formData.uname = 'all'
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawLine('traffic-chart')
    })
    this.changeSon()
    this.start()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.charts) {
      this.charts.dispose()
    }
  },
}
</script>

<style scoped lang="less">
.traffic-page {
  padding: 24px;
  background: #ffffff;
  min-height: calc(100vh - 98px);
}

/* 卡片样式 */
.content-card {
  border-radius: 16px;
  margin-bottom: 32px;
  // box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: white;
  // border: 1px solid #f5f5f5;
  padding: 16px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-color: #e6f7ff;
  }

  :deep(.ant-card-body) {
    padding: 36px;
  }
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f0f0f0;
  transition: all 0.3s ease;

  .header-icon {
    font-size: 28px;
    color: #1890ff;
    margin-right: 20px;
    transition: all 0.3s ease;
  }

  .header-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.5px;
  }
}

/* 表单样式 */
:deep(.ant-form-inline .ant-form-item) {
  margin-bottom: 0;
  margin-right: 16px;
}

/* 按钮样式 */
:deep(.ant-btn) {
  transition: all 0.3s ease;
  border-radius: 6px;
  font-weight: 500;
}

:deep(.ant-btn-primary) {
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  border: none;
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.3);
  
  &:hover {
    background: linear-gradient(135deg, #40a9ff 0%, #69c0ff 100%);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
    transform: translateY(-1px);
  }
}

.traffic-chart {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: white;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .traffic-page {
    padding: 16px;
  }
  
  .content-card {
    :deep(.ant-card-body) {
      padding: 16px;
    }
  }
  
  .card-header {
    margin-bottom: 16px;
    padding-bottom: 16px;

    .header-icon {
      font-size: 24px;
      margin-right: 16px;
    }

    .header-title {
      font-size: 18px;
    }
  }
  
  :deep(.ant-form-inline) {
    flex-direction: column;
    align-items: flex-start;
  }
  
  :deep(.ant-form-inline .ant-form-item) {
    margin-right: 0;
    margin-bottom: 16px;
  }
  
  .traffic-chart {
    height: 400px !important;
  }
}
</style>